import { render, staticRenderFns } from "./pay_prompt.vue?vue&type=template&id=20f6c011&scoped=true"
import script from "./pay_prompt.vue?vue&type=script&lang=js"
export * from "./pay_prompt.vue?vue&type=script&lang=js"
import style0 from "./pay_prompt.vue?vue&type=style&index=0&id=20f6c011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6c011",
  null
  
)

export default component.exports